import { render, staticRenderFns } from "./PagePagoResponsable.vue?vue&type=template&id=db2c8efc&"
import script from "./PagePagoResponsable.vue?vue&type=script&lang=js&"
export * from "./PagePagoResponsable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports